//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const SpecialEventDecoration = () => import(
/* webpackMode: "eager" */
'~/components/atoms/Product/Decorations/SpecialEventDecoration.vue');

export default {
  name: 'TheSpecialEventSection',
  components: {
    SpecialEventDecoration
  },
  props: {
    special: {
      type: Object,
      required: true
    }
  }
};